import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import cartStore from "@/modules/cart/store/cart.store.js";
import menuStore from "@/modules/menu/store/menu.store";
import favoritesStore from "@/modules/menu/store/favorites.store";
import i18n from "@/i18n";
import axios from "axios";
import {BASE_API_URL} from "@/appConstants";
import router from "@/router/router";
import { v4 as uuidv4 } from 'uuid';

Vue.use(Vuex)

axios.interceptors.response.use(
    function (response) {
        // If response status is 200
        return response;
    },
    function (error) {

        // If network error - redirect to error page
        if (Object.prototype.hasOwnProperty.call(error.toJSON(), 'message') && error.toJSON().message === 'Network Error') {
            router.push({
                name: 'error',
                params: {
                    errorTitle: i18n.t('errors.NETWORK_ERROR.title'),
                    errorMessage: i18n.t('errors.NETWORK_ERROR.message')
                }
            })
        }

        // If response status is not 200  - handle error}
        if (error.response) {
            if (error.response.status === 500) {
                // handling errors from server by status code 500 & message as key
                if (Object.prototype.hasOwnProperty.call(error.response.data, 'message') &&
                    (Object.prototype.hasOwnProperty.call(error.response.data, 'status') &&
                        error.response.data.status === 'error')) {

                    // Vue.$toast.error(
                    //     i18n.t(`errors.${error.response.data.message}`) ||
                    //     i18n.t('errors.DEFAULT_ERROR_IF_KEY_NOT_FOUND')
                    // )
                }
            }

        }

        return Promise.reject(error);
    }
);


export const store = new Vuex.Store({
    modules: {
        cartStore: cartStore,
        menuStore: menuStore,
        favoritesStore: favoritesStore
    },
    plugins: [createPersistedState({
        storage: window.sessionStorage,
    })],
    state: {
        count: 0,
        companyData: {},
        companyName: null,
        userLocale: 'pl_PL',
        tableId: null,
        tableData: null,
        fingerprint_new: null,
        token: null,
        showBottomMenu: true,
        // carts: [],
        prefLangCode: null,
        lastOrderId: null,
        redirect: ""
    },
    mutations: {
        increment(state) {
            state.count++
        },
        saveCompanyData(state, val) {
            state.companyData = val;
        },
        saveToken(state, val) {
            state.token = val;
        },
        saveFingerprint(state, val) {
            state.fingerprint_new = val;
        },
        saveCompanyName(state, val) {
            state.companyName = val;
        },
        saveLastOrderId(state, val) {
            state.lastOrderId = val;
        },
        showBottomMenu(state, val) {
            state.showBottomMenu = val;
        },
        setPrefLangCode(state, val) {
            state.prefLangCode = val;
        },
        SET_TABLE_DATA(state, tableData) {
            if (tableData === null) {

                state.tableData = null
                state.tableId = null

            } else {
                state.tableData = tableData
            }
        },
        SET_COMPANY_NAME(state, companyName) {
            state.companyName = companyName
        },
        SET_COMPANY_DATA(state, companyData) {
            state.companyData = companyData
        },
        SET_FINGERPRINT(state, fingerprint) {

            var fingerprint_old = localStorage.getItem('myrest_' + state.companyName + '_fingerprint_new');
            if (!fingerprint_old) {
                state.fingerprint_new = fingerprint
                localStorage.setItem('myrest_' + state.companyName + '_fingerprint_new', fingerprint);
            } else {
                state.fingerprint_new = fingerprint_old
            }
        },
        SET_USER_LOCALE(state, locale) {
            state.userLocale = locale
        },
        SET_TABLE_ID(state, tableId) {
            state.tableId = tableId
        },
        addToCart(state, item) {
            state.carts.push(item);
        },
        removeFromCart(state, item) {
            let id = item.id;
            let list = state.carts;
            let index = list.map(x => {
                return x.id;
            }).indexOf(id);

            this.carts = list.splice(index, 1);
        },
        SET_REDIRECT(state, redirect){
            state.redirect = redirect;
        }
    },
    actions: {
        FETCH_AND_SET_TABLE_DATA({commit}, tableId) {

            axios
                .get(`${BASE_API_URL}site/table/${tableId}`)
                .then(response => {
                    if (response.data.status === 200) {
                        commit('SET_TABLE_DATA', response.data.table)
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status === 404) {
                        commit('SET_TABLE_DATA', null)
                    } else {
                        commit('SET_TABLE_DATA', null)
                    }
                })
        },
        FETCH_AND_SET_TABLE_DATA_FROM_QR_CODE({dispatch,commit}, code) {
            axios
                .get(`${BASE_API_URL}site/fetchqr/${code}`)
                .then(response => {
                    if (response.data.status === 200) {
                        commit('SET_COMPANY_NAME', response.data.locale.code)
                        if(response.data.table) {
                            commit('SET_TABLE_DATA', response.data.table)
                            dispatch('FETCH_AND_SET_INITIAL_APP_DATA', response.data.table.id)
                        } else {
                            dispatch('FETCH_AND_SET_INITIAL_APP_DATA')
                        }
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status === 404) {
                        commit('SET_TABLE_DATA', null)
                    }

                })
        },
        FETCH_AND_SET_COMPANY_NAME({commit}, companyName) {
            commit('SET_COMPANY_NAME', companyName)
        },
        FETCH_AND_SET_FINGERPRINT({commit}, fingerprint) {
            commit('SET_FINGERPRINT', fingerprint)
        },
        FETCH_AND_SET_USER_LOCALE({commit, state}, localeParam = null) {
            if (localeParam !== null && localeParam !== undefined) {
                commit('SET_USER_LOCALE', localeParam)
                i18n.locale = localeParam
            } else {
                const locale = window.navigator.userLanguage || window.navigator.language;

                if (!!locale && (locale !== state.userLocale)) {
                    commit('SET_USER_LOCALE', locale)
                    i18n.locale = locale
                } else {
                    i18n.locale = state.userLocale
                }
            }
        },
        FETCH_AND_SET_INITIAL_APP_DATA({dispatch, commit, state, rootGetters}, tableId = null) {
            if (!state.fingerprint_new) {
                dispatch("FETCH_AND_SET_FINGERPRINT", uuidv4())
            }
            dispatch("FETCH_AND_SET_USER_LOCALE")

            var currentRoute = router.currentRoute;

            commit('SET_TABLE_ID', tableId)

            axios({
                method: 'get',
                url: `${BASE_API_URL}locale?code=${state.companyName}&identifier=${state.fingerprint_new}&pref_lang_code=${state.userLocale}&table_id=${tableId}`
            })
                .then(response => {
                    if (response.status === 200) {
                        switch (state.redirect) {
                            case "menu":
                                router.push("menu");
                                break;
                            case "review":
                                router.push("review");
                                break;
                            default:
                                if (currentRoute.name !== 'result') {
                                    router.push('welcome');
                                } else {
                                    router.go(0);
                                }
                        }

                        let oldLocaleId = null;
                        if (rootGetters['getCompanyData'].locale) {
                            oldLocaleId = rootGetters['getCompanyData'].locale.id;
                        }

                        commit('SET_COMPANY_DATA', response.data);

                        if (oldLocaleId && oldLocaleId !== rootGetters['getCompanyData'].locale.id) {
                            dispatch('cartStore/CLEAR_CART');
                            dispatch('cartStore/CLEAR_ORDERS');
                        }

                    } else {
                        if (currentRoute.name !== 'result')  {
                            router.push('error')
                        } else {
                            router.go(0)
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })

            // const endpoint = BASE_API_URL +
            //     'locale?code=' + state.companyName +
            //     '&identifier=' + state.fingerprint +
            //     '&pref_lang_code=' + this.userLanguage;
            // axios.get(endpoint).then(
            //     response => {
            //
            //         // console.log('resp: ', response)
            //
            //         this.companyData = response.data;
            //         this.$store.commit('saveCompanyData', this.companyData);
            //         router.push('welcome');
            //     }
            // ).catch((error) => {
            //     // router.push('error');
            //     console.log('Error: ', error);
            // })


        },
        SET_REDIRECT({ commit }, redirect) {
            let val = "";
            switch(redirect){
                case "m":
                case "menu":
                    val = "menu";
                    break;
                case "r":
                case "review":
                    val = "review";
                    break;
                default:
                    val = "";
            }

            commit('SET_REDIRECT', val);
        },
    },
    getters: {
        getTableData: state => state.tableData,
        getTableNum: state => {
            if (state.tableData !== null) {
                return state.tableData.table_number
            } else {
                return null
            }
        },
        getTableName: state => {
            if (state.tableData !== null) {
                return state.tableData.name
            } else {
                return null
            }
        },
        getCompanyData: state => state.companyData,
        getCompanyName: state => state.companyName,
        getCurrentLocale: state => state.userLocale,
        getIsModeWMM: state => state.companyData.locale.smart_menu_mode === 'wmm',
        getIsModeQSR: state => state.companyData.locale.smart_menu_mode === 'qsr',
        getIsModeSOT: state => state.companyData.locale.smart_menu_mode === 'sot',
        getIsModeHOT: state => state.companyData.locale.smart_menu_mode === 'hot',
        getCartEnabled: state => state.companyData.locale.smart_menu_cart_enabled,
        getLastOrderId: state => state.lastOrderId,
        getFingerprint: state => state.fingerprint_new,
        getPrefLangCode: state => state.prefLangCode,
        getCustomCSS: state => {
            if (state.companyData && state.companyData.locale && state.companyData.locale.sm_custom_css) {
                return state.companyData.locale.sm_custom_css
            } else {
                return null
            }
        },
        getStoreMode: state => {
            let type = 'wmm';
            if (state.companyData.locale.smart_menu_mode === 'qsr') {

                type = 'qsr';

                if (state.companyData.locale.smart_menu_sms_enabled) {
                    type = 'qsrsms';
                }

            } else if (state.tableData !== null) {
                type = 'menu'
            }
            return type
        },
        getDeliveryMethods: state => state.companyData.locale.sm_delivery_methods,
        getPaymentMethods: state => state.companyData.locale.sm_payment_methods,
        getWaitersList: state => state.companyData.locale.waiters || [],
        getBrandColor: state => {
            return (state.companyData && state.companyData.colors && state.companyData.colors.main) || null
        }
    }
})
